// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #06b6d4;
  --primary-hover: #0891b2;
  --primary-light: #cffafe;
  --success-color: #10b981;
  --error-color: #ef4444;
  --warning-color: #f59e0b;
  --info-color: #3b82f6;
  --bg-color: #ffffff;
  --card-bg: #ffffff;
  --text-primary: #000000;
  --text-secondary: #6b7280;
  --border-color: #e5e7eb;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #ffffff;
  min-height: 100vh;
  padding: 20px;
  line-height: 1.6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

#app {
  width: 100%;
  max-width: 1200px;
  position: relative;
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo-container img {
  width: 100%;
  max-width: 600px;
  height: auto;
}

/* Media Player */
.media-player {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  z-index: 500;
  display: none;
}

.media-player.active {
  display: block;
}

.media-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: none;
}

.media-element.active {
  display: block;
}

/* Playback Stats Overlay */
.playback-stats-overlay {
  position: fixed;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px;
  border-radius: 10px;
  max-width: 300px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 700;
  font-family: 'Segoe UI', sans-serif;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  display: none;
}

.playback-stats-overlay.hidden {
  display: none;
}

.playback-stats-overlay.visible {
  display: block;
}

.playback-stats-overlay .stats-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  color: #06b6d4;
}

.playback-stats-overlay .stats-content {
  font-size: 12px;
  line-height: 1.6;
}

.playback-stats-overlay .stats-empty {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
  text-align: center;
  padding: 10px 0;
}

.playback-stats-overlay .stat-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.playback-stats-overlay .stat-item:last-child {
  border-bottom: none;
}

.playback-stats-overlay .stat-label {
  color: rgba(255, 255, 255, 0.8);
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
  line-height: 1;
}

.playback-stats-overlay .stat-value {
  color: #10b981;
  font-weight: 600;
  min-width: 40px;
  text-align: right;
  line-height: 1;
}

.playback-stats-overlay::-webkit-scrollbar {
  width: 6px;
}

.playback-stats-overlay::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.playback-stats-overlay::-webkit-scrollbar-thumb {
  background: rgba(6, 182, 212, 0.5);
  border-radius: 3px;
}

.playback-stats-overlay::-webkit-scrollbar-thumb:hover {
  background: rgba(6, 182, 212, 0.8);
}

/* Playback Controls */
.playback-controls {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  z-index: 600;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.playback-controls.hidden {
  opacity: 0;
  pointer-events: none;
}

.playback-info {
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  padding: 8px 16px;
  border-radius: 20px;
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.playback-buttons {
  display: flex !important;
  flex-direction: row !important;
  gap: 20px;
  align-items: center;
}

.playback-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  background: rgba(39, 109, 90, 0.5);
  color: white;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
}

.playback-btn:hover {
  background: #276d5a;
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

.playback-btn:active {
  transform: scale(0.95);
}

#prevBtn {
  padding-left: 0;
  text-indent: -5px;
}

#nextBtn {
  padding-left: 0;
  text-indent: 5px;
}

/* Spinner */
.spinner-container {
  text-align: center;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(39, 109, 90, 0.2);
  border-top: 5px solid #276d5a;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.spinner-progress-text {
  color: #06b6d4;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  background: var(--card-bg);
  border-radius: 15px;
  overflow: hidden;
}

.status-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.header {
  background: var(--primary-color);
  color: white;
  padding: 30px;
  text-align: center;
}

.header h1 {
  margin-bottom: 15px;
  font-size: 32px;
  font-weight: 600;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  color: var(--text-primary);
  background: var(--bg-color);
}

.status::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  transition: all 0.3s ease;
}

.status.disconnected::before {
  background: var(--error-color);
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
}

.status.connected {
  animation: pulse 2s infinite;
}

.status.connected::before {
  background: var(--success-color);
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.3);
  animation: blink 1.5s infinite;
}

.status.authenticating::before {
  background: var(--warning-color);
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.toggle-debug-btn {
  background: white;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.toggle-debug-btn:hover {
  background: var(--primary-color);
  color: white;
  transform: translateY(-2px);
}

.toggle-debug-btn:active {
  transform: translateY(0);
}

.debug-sections {
  animation: fadeIn 0.3s ease;
  display: none !important;
}

.debug-sections.hidden {
  display: none !important;
}

.content:has(.debug-sections[style*='display: none']) {
  display: none;
}

.container:has(.debug-sections[style*='display: none']) {
  display: none;
}

.container {
  display: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.content {
  padding: 30px;
}

.section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--text-primary);
  border-bottom: 3px solid var(--primary-color);
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.credential-presets {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 25px;
}

/* Compact Connection Layout */
.connection-compact-layout {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.credential-presets-compact {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.radio-option-compact {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 2px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--bg-color);
  font-size: 14px;
}

.radio-option-compact:hover {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.radio-option-compact input[type='radio'] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--primary-color);
}

.radio-option-compact input[type='radio']:checked + span {
  font-weight: 600;
  color: var(--primary-color);
}

.credentials-row {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.input-group-compact {
  flex: 1;
  min-width: 0;
}

.input-group-compact label {
  display: block;
  margin-bottom: 4px;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 12px;
}

.input-group-compact input {
  width: 100%;
  padding: 8px 10px;
  border: 2px solid var(--border-color);
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.3s ease;
  background: var(--bg-color);
}

.input-group-compact input:focus {
  outline: none;
  border-color: var(--primary-color);
  background: white;
}

.input-group-compact input:disabled {
  background: #f9fafb;
  color: var(--text-secondary);
  cursor: not-allowed;
  opacity: 0.7;
}

.button-group-compact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.button-group-compact button {
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 6px;
  white-space: nowrap;
}

.stats-grid-compact {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border-color);
}

.stat-card-compact {
  background: var(--bg-color);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  text-align: center;
}

.stat-card-compact .stat-label {
  font-size: 11px;
  color: var(--text-secondary);
  margin-bottom: 4px;
  font-weight: 500;
}

.stat-card-compact .stat-value {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border: 2px solid var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--bg-color);
}

.radio-option:hover {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.radio-option input[type='radio'] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--primary-color);
}

.radio-option input[type='radio']:checked + span {
  font-weight: 600;
  color: var(--primary-color);
}

.radio-option span {
  font-size: 14px;
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 14px;
}

.input-group input {
  width: 100%;
  padding: 14px;
  border: 2px solid var(--border-color);
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: var(--bg-color);
}

.input-group input:focus {
  outline: none;
  border-color: var(--primary-color);
  background: white;
}

.input-group input:disabled {
  background: #f9fafb;
  color: var(--text-secondary);
  cursor: not-allowed;
  opacity: 0.7;
}

.button-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover:not(:disabled) {
  background: var(--primary-hover);
  transform: translateY(-2px);
}

button:active:not(:disabled) {
  transform: translateY(0);
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.info-text {
  margin-top: 15px;
  color: var(--text-secondary);
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Statistics Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.stat-card {
  background: var(--bg-color);
  padding: 20px;
  border-radius: 12px;
  border: 2px solid var(--border-color);
  transition: all 0.3s ease;
}

.stat-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-3px);
}

.stat-label {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
}

/* Log Container */
.log-container {
  background: var(--bg-color);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
  height: 400px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

.log-container::-webkit-scrollbar {
  width: 8px;
}

.log-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.log-container::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 10px;
}

.log-container::-webkit-scrollbar-thumb:hover {
  background: var(--primary-hover);
}

.log-entry {
  padding: 8px 0;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  gap: 10px;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.log-entry:last-child {
  border-bottom: none;
}

.log-time {
  color: var(--text-secondary);
  font-weight: 600;
  min-width: 90px;
}

.log-type {
  font-weight: 700;
  min-width: 80px;
}

.log-type-received {
  color: var(--success-color);
}

.log-type-sent {
  color: var(--info-color);
}

.log-type-error {
  color: var(--error-color);
}

.log-type-info {
  color: var(--warning-color);
}

.log-type-success {
  color: var(--success-color);
  font-weight: 600;
}

.log-type-warning {
  color: #ff9800;
  font-weight: 500;
}

.log-message {
  flex: 1;
  word-break: break-word;
}

/* Fullscreen Toggle Button (Fixed Bottom Left) */
.fullscreen-toggle-btn {
  position: fixed;
  bottom: 30px;
  left: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(39, 109, 90, 0.5);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 0;
  opacity: 1;
  font-size: 28px;
  line-height: 1;
}

.fullscreen-toggle-btn.hidden {
  opacity: 0;
  pointer-events: none;
}

.fullscreen-toggle-btn:hover {
  background: #276d5a;
  transform: scale(1.1);
}

.fullscreen-toggle-btn:active {
  transform: scale(0.95);
}

/* Settings Toggle Button (Fixed Bottom Right) */
.settings-toggle-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(39, 109, 90, 0.5);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 0;
  opacity: 1;
}

.settings-toggle-btn.hidden {
  opacity: 0;
  pointer-events: none;
}

.settings-toggle-btn img {
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
}

.settings-toggle-btn:hover {
  background: #276d5a;
  transform: scale(1.1);
}

.settings-toggle-btn:active {
  transform: scale(0.95);
}

/* Settings Modal */
.settings-modal {
  display: none;
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease;
}

.settings-modal.show {
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-modal-content {
  background-color: var(--card-bg);
  border-radius: 15px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.settings-modal-header {
  background: var(--primary-color);
  color: white;
  padding: 20px 30px;
  border-radius: 15px 15px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-modal-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.settings-modal-header h2::before {
  content: '';
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: var(--settings-icon-url);
  background-size: contain;
  background-repeat: no-repeat;
  filter: brightness(0) invert(1);
}

.modal-header-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.settings-close-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 36px;
  cursor: pointer;
  padding: 0;
  padding-bottom: 4px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.settings-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.settings-modal-body {
  padding: 20px;
}

.accordion-section {
  margin-bottom: 10px;
  border: 2px solid var(--border-color);
  border-radius: 10px;
  overflow: hidden;
}

.accordion-header {
  width: 100%;
  padding: 15px 20px;
  background: var(--bg-color);
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  transition: all 0.3s ease;
  text-align: left;
}

.accordion-header:hover {
  background: var(--primary-light);
}

.accordion-header.active {
  background: var(--primary-color);
  color: white;
}

.accordion-icon {
  transition: transform 0.3s ease;
  font-size: 12px;
}

.accordion-header.active .accordion-icon {
  transform: rotate(180deg);
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 20px;
  background: white;
}

.accordion-content.open {
  max-height: 2000px;
  padding: 20px;
}

.modal-section-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 15px;
  margin-top: 0;
}

.settings-divider {
  border: none;
  border-top: 2px solid var(--border-color);
  margin: 20px 0;
}

.toggle-option {
  margin: 15px 0;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary);
}

.toggle-label input[type='checkbox'] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--primary-color);
}

.toggle-description {
  margin: 5px 0 0 30px;
  font-size: 13px;
  color: var(--text-secondary);
  font-style: italic;
}

.modal-divider {
  border: none;
  border-top: 2px solid var(--border-color);
  margin: 25px 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    margin: 10px;
  }

  .content {
    padding: 20px;
  }

  .header h1 {
    font-size: 24px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .button-group {
    flex-direction: column;
  }

  button {
    width: 100%;
  }
  /* 
  .settings-toggle-btn {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  } */

  .settings-modal-content {
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;EAC7C,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;EACA;;;;;;KAMG;;EAEH;IACE,UAAU;EACZ;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --primary-color: #06b6d4;\n  --primary-hover: #0891b2;\n  --primary-light: #cffafe;\n  --success-color: #10b981;\n  --error-color: #ef4444;\n  --warning-color: #f59e0b;\n  --info-color: #3b82f6;\n  --bg-color: #ffffff;\n  --card-bg: #ffffff;\n  --text-primary: #000000;\n  --text-secondary: #6b7280;\n  --border-color: #e5e7eb;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background: #ffffff;\n  min-height: 100vh;\n  padding: 20px;\n  line-height: 1.6;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n#app {\n  width: 100%;\n  max-width: 1200px;\n  position: relative;\n}\n\n.logo-container {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.logo-container img {\n  width: 100%;\n  max-width: 600px;\n  height: auto;\n}\n\n/* Media Player */\n.media-player {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #000;\n  z-index: 500;\n  display: none;\n}\n\n.media-player.active {\n  display: block;\n}\n\n.media-element {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: none;\n}\n\n.media-element.active {\n  display: block;\n}\n\n/* Playback Stats Overlay */\n.playback-stats-overlay {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 15px;\n  border-radius: 10px;\n  max-width: 300px;\n  max-height: 400px;\n  overflow-y: auto;\n  z-index: 700;\n  font-family: 'Segoe UI', sans-serif;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n  display: none;\n}\n\n.playback-stats-overlay.hidden {\n  display: none;\n}\n\n.playback-stats-overlay.visible {\n  display: block;\n}\n\n.playback-stats-overlay .stats-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  color: #06b6d4;\n}\n\n.playback-stats-overlay .stats-content {\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.playback-stats-overlay .stats-empty {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n  text-align: center;\n  padding: 10px 0;\n}\n\n.playback-stats-overlay .stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 5px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.playback-stats-overlay .stat-item:last-child {\n  border-bottom: none;\n}\n\n.playback-stats-overlay .stat-label {\n  color: rgba(255, 255, 255, 0.8);\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 10px;\n  line-height: 1;\n}\n\n.playback-stats-overlay .stat-value {\n  color: #10b981;\n  font-weight: 600;\n  min-width: 40px;\n  text-align: right;\n  line-height: 1;\n}\n\n.playback-stats-overlay::-webkit-scrollbar {\n  width: 6px;\n}\n\n.playback-stats-overlay::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n.playback-stats-overlay::-webkit-scrollbar-thumb {\n  background: rgba(6, 182, 212, 0.5);\n  border-radius: 3px;\n}\n\n.playback-stats-overlay::-webkit-scrollbar-thumb:hover {\n  background: rgba(6, 182, 212, 0.8);\n}\n\n/* Playback Controls */\n.playback-controls {\n  position: fixed;\n  bottom: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  z-index: 600;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.playback-controls.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.playback-info {\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 8px 16px;\n  border-radius: 20px;\n  max-width: 400px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.playback-buttons {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 20px;\n  align-items: center;\n}\n\n.playback-btn {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(39, 109, 90, 0.5);\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  line-height: 1;\n}\n\n.playback-btn:hover {\n  background: #276d5a;\n  transform: scale(1.1);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n}\n\n.playback-btn:active {\n  transform: scale(0.95);\n}\n\n#prevBtn {\n  padding-left: 0;\n  text-indent: -5px;\n}\n\n#nextBtn {\n  padding-left: 0;\n  text-indent: 5px;\n}\n\n/* Spinner */\n.spinner-container {\n  text-align: center;\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(39, 109, 90, 0.2);\n  border-top: 5px solid #276d5a;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n.spinner-progress-text {\n  color: #06b6d4;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: var(--card-bg);\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n.status-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.header {\n  background: var(--primary-color);\n  color: white;\n  padding: 30px;\n  text-align: center;\n}\n\n.header h1 {\n  margin-bottom: 15px;\n  font-size: 32px;\n  font-weight: 600;\n}\n\n.status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  color: var(--text-primary);\n  background: var(--bg-color);\n}\n\n.status::before {\n  content: '';\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  transition: all 0.3s ease;\n}\n\n.status.disconnected::before {\n  background: var(--error-color);\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n}\n\n.status.connected {\n  animation: pulse 2s infinite;\n}\n\n.status.connected::before {\n  background: var(--success-color);\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.3);\n  animation: blink 1.5s infinite;\n}\n\n.status.authenticating::before {\n  background: var(--warning-color);\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n}\n\n@keyframes blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n}\n\n.toggle-debug-btn {\n  background: white;\n  border: 2px solid var(--primary-color);\n  color: var(--primary-color);\n  padding: 12px 24px;\n  border-radius: 25px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.toggle-debug-btn:hover {\n  background: var(--primary-color);\n  color: white;\n  transform: translateY(-2px);\n}\n\n.toggle-debug-btn:active {\n  transform: translateY(0);\n}\n\n.debug-sections {\n  animation: fadeIn 0.3s ease;\n  display: none !important;\n}\n\n.debug-sections.hidden {\n  display: none !important;\n}\n\n.content:has(.debug-sections[style*='display: none']) {\n  display: none;\n}\n\n.container:has(.debug-sections[style*='display: none']) {\n  display: none;\n}\n\n.container {\n  display: none;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.content {\n  padding: 30px;\n}\n\n.section {\n  margin-bottom: 30px;\n}\n\n.section-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: var(--text-primary);\n  border-bottom: 3px solid var(--primary-color);\n  padding-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.credential-presets {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-bottom: 25px;\n}\n\n/* Compact Connection Layout */\n.connection-compact-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.credential-presets-compact {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.radio-option-compact {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border: 2px solid var(--border-color);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--bg-color);\n  font-size: 14px;\n}\n\n.radio-option-compact:hover {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.radio-option-compact input[type='radio'] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--primary-color);\n}\n\n.radio-option-compact input[type='radio']:checked + span {\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.credentials-row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n.input-group-compact {\n  flex: 1;\n  min-width: 0;\n}\n\n.input-group-compact label {\n  display: block;\n  margin-bottom: 4px;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.input-group-compact input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 2px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 13px;\n  transition: all 0.3s ease;\n  background: var(--bg-color);\n}\n\n.input-group-compact input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  background: white;\n}\n\n.input-group-compact input:disabled {\n  background: #f9fafb;\n  color: var(--text-secondary);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.button-group-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.button-group-compact button {\n  padding: 10px 18px;\n  font-size: 14px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.stats-grid-compact {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid var(--border-color);\n}\n\n.stat-card-compact {\n  background: var(--bg-color);\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  text-align: center;\n}\n\n.stat-card-compact .stat-label {\n  font-size: 11px;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.stat-card-compact .stat-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border: 2px solid var(--border-color);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: var(--bg-color);\n}\n\n.radio-option:hover {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.radio-option input[type='radio'] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--primary-color);\n}\n\n.radio-option input[type='radio']:checked + span {\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.radio-option span {\n  font-size: 14px;\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n}\n\n.input-group {\n  margin-bottom: 20px;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.input-group input {\n  width: 100%;\n  padding: 14px;\n  border: 2px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  background: var(--bg-color);\n}\n\n.input-group input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  background: white;\n}\n\n.input-group input:disabled {\n  background: #f9fafb;\n  color: var(--text-secondary);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.button-group {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\nbutton {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\nbutton:hover:not(:disabled) {\n  background: var(--primary-hover);\n  transform: translateY(-2px);\n}\n\nbutton:active:not(:disabled) {\n  transform: translateY(0);\n}\n\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.info-text {\n  margin-top: 15px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Statistics Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.stat-card {\n  background: var(--bg-color);\n  padding: 20px;\n  border-radius: 12px;\n  border: 2px solid var(--border-color);\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  border-color: var(--primary-color);\n  transform: translateY(-3px);\n}\n\n.stat-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Log Container */\n.log-container {\n  background: var(--bg-color);\n  border: 2px solid var(--border-color);\n  border-radius: 12px;\n  padding: 20px;\n  height: 400px;\n  overflow-y: auto;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n}\n\n.log-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.log-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.log-container::-webkit-scrollbar-thumb {\n  background: var(--primary-color);\n  border-radius: 10px;\n}\n\n.log-container::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-hover);\n}\n\n.log-entry {\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  gap: 10px;\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.log-entry:last-child {\n  border-bottom: none;\n}\n\n.log-time {\n  color: var(--text-secondary);\n  font-weight: 600;\n  min-width: 90px;\n}\n\n.log-type {\n  font-weight: 700;\n  min-width: 80px;\n}\n\n.log-type-received {\n  color: var(--success-color);\n}\n\n.log-type-sent {\n  color: var(--info-color);\n}\n\n.log-type-error {\n  color: var(--error-color);\n}\n\n.log-type-info {\n  color: var(--warning-color);\n}\n\n.log-type-success {\n  color: var(--success-color);\n  font-weight: 600;\n}\n\n.log-type-warning {\n  color: #ff9800;\n  font-weight: 500;\n}\n\n.log-message {\n  flex: 1;\n  word-break: break-word;\n}\n\n/* Fullscreen Toggle Button (Fixed Bottom Left) */\n.fullscreen-toggle-btn {\n  position: fixed;\n  bottom: 30px;\n  left: 30px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: rgba(39, 109, 90, 0.5);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  padding: 0;\n  opacity: 1;\n  font-size: 28px;\n  line-height: 1;\n}\n\n.fullscreen-toggle-btn.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.fullscreen-toggle-btn:hover {\n  background: #276d5a;\n  transform: scale(1.1);\n}\n\n.fullscreen-toggle-btn:active {\n  transform: scale(0.95);\n}\n\n/* Settings Toggle Button (Fixed Bottom Right) */\n.settings-toggle-btn {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: rgba(39, 109, 90, 0.5);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  padding: 0;\n  opacity: 1;\n}\n\n.settings-toggle-btn.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.settings-toggle-btn img {\n  width: 30px;\n  height: 30px;\n  filter: brightness(0) invert(1);\n}\n\n.settings-toggle-btn:hover {\n  background: #276d5a;\n  transform: scale(1.1);\n}\n\n.settings-toggle-btn:active {\n  transform: scale(0.95);\n}\n\n/* Settings Modal */\n.settings-modal {\n  display: none;\n  position: fixed;\n  z-index: 2000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  animation: fadeIn 0.3s ease;\n}\n\n.settings-modal.show {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings-modal-content {\n  background-color: var(--card-bg);\n  border-radius: 15px;\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.settings-modal-header {\n  background: var(--primary-color);\n  color: white;\n  padding: 20px 30px;\n  border-radius: 15px 15px 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.settings-modal-header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.settings-modal-header h2::before {\n  content: '';\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  background-image: var(--settings-icon-url);\n  background-size: contain;\n  background-repeat: no-repeat;\n  filter: brightness(0) invert(1);\n}\n\n.modal-header-icon {\n  width: 24px;\n  height: 24px;\n  filter: brightness(0) invert(1);\n}\n\n.settings-close-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 36px;\n  cursor: pointer;\n  padding: 0;\n  padding-bottom: 4px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.settings-close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: rotate(90deg);\n}\n\n.settings-modal-body {\n  padding: 20px;\n}\n\n.accordion-section {\n  margin-bottom: 10px;\n  border: 2px solid var(--border-color);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.accordion-header {\n  width: 100%;\n  padding: 15px 20px;\n  background: var(--bg-color);\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n  text-align: left;\n}\n\n.accordion-header:hover {\n  background: var(--primary-light);\n}\n\n.accordion-header.active {\n  background: var(--primary-color);\n  color: white;\n}\n\n.accordion-icon {\n  transition: transform 0.3s ease;\n  font-size: 12px;\n}\n\n.accordion-header.active .accordion-icon {\n  transform: rotate(180deg);\n}\n\n.accordion-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease, padding 0.3s ease;\n  padding: 0 20px;\n  background: white;\n}\n\n.accordion-content.open {\n  max-height: 2000px;\n  padding: 20px;\n}\n\n.modal-section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 15px;\n  margin-top: 0;\n}\n\n.settings-divider {\n  border: none;\n  border-top: 2px solid var(--border-color);\n  margin: 20px 0;\n}\n\n.toggle-option {\n  margin: 15px 0;\n}\n\n.toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-primary);\n}\n\n.toggle-label input[type='checkbox'] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--primary-color);\n}\n\n.toggle-description {\n  margin: 5px 0 0 30px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.modal-divider {\n  border: none;\n  border-top: 2px solid var(--border-color);\n  margin: 25px 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    margin: 10px;\n  }\n\n  .content {\n    padding: 20px;\n  }\n\n  .header h1 {\n    font-size: 24px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .button-group {\n    flex-direction: column;\n  }\n\n  button {\n    width: 100%;\n  }\n  /* \n  .settings-toggle-btn {\n    bottom: 20px;\n    right: 20px;\n    width: 50px;\n    height: 50px;\n  } */\n\n  .settings-modal-content {\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
